import Repository from '../axios';

const resource = "/admin/system_setting";

export default {
  getCompanyAddresses(filterQuery = '', sort = 'name') {
    let url = `${resource}/company-addresses?paginate=5&is_paginate=0`;
    if (sort) {
      url += `&sort=${sort}`;
    }
    if (filterQuery) {
      url += `&${filterQuery}`;
    }
    return Repository.get(url);
  },
  getListOfCompanyAddresses(filterQuery = '', sort = 'name') {
    return this.getCompanyAddresses(filterQuery, sort);
  },
  getCompanyAddress(id) {
    return Repository.get(`${resource}/company-addresses/${id}`);
  },
  createCompanyAddress(payload) {
    return Repository.post(`${resource}/company-addresses`, payload);
  },
  updateCompanyAddress(id, payload) {
    return Repository.put(`${resource}/company-addresses/${id}`, payload);
  },
  deleteCompanyAddress(id) {
    return Repository.delete(`${resource}/company-addresses/${id}`);
  }
};
